module.exports = require("react-select/async");